import { SLMap } from '../sl-map';
import { SLLayer, LayerTypeEnum, LayerGeomtypes } from '../sl-layer';
import { SelectedResultsLayer } from './selected-results-layer';
import { UnSelectedResultsLayer } from './unselected-results-layer';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { ResultsService, ResultChange, ContextState, ResultMoment } from 'src/app/services/results.service';
import { Synchable, SynchEvent, ISelectionData } from '../synchronizer';
import { EventEmitter, Output } from '@angular/core';
import { InterruptableTimer } from '../interruptabletimer';
import { MapDataAction } from '../map-actions/map_data-action';
import { ColorClass } from 'src/app/types/color-class';
import { ResultHistory } from '../result-history';

export class ResultsLayer extends SLLayer {
  public selections: ContextState = null;
  public selectionData: ISelectionData = null;
  public renderingPUC = false;
  public renderingResultList = false;
  public renderingInfo = false;
  public get hasMoment() {
    return !!this.moment;
  }
  public get hasResults() {
    return this.renderingInfo || this.isRenderingList || this.isRenderingPuc;
  }
  public get hasHistory() {
    return !!this.resultsSvc.history.lastMoment;
  }
  public hasResultsChange = new EventEmitter<boolean>();
  public sourceLayer: SLLayer;
  private legendary = false;

  public labelInfo: any = {
    labelField: '_sl_inherit_',
    labelStyleJSON: {
      font: 'RobotoBlack', size: 12, color: '#ffffff',
      align: 'center', outlinecolor: '#000000', outlinewidth: 2, shadowcolor: '#ededed',
      shadowsizex: 0, shadowsizey: 5, offsetx: 0, offsety: 20, position: 'lc'
    },
    inheritLabelStyle: true,
    labelOverride: '',
    override: false,
    labelsOn: true
  };
  private resultTimer: InterruptableTimer = new InterruptableTimer(500);
  // private features: Array<any>;
  private subs: Array<SLLayer> = [];
  private moment: ResultMoment = null;
  public inheritLabels = false;




  public set listHasMoment(isSet: boolean) {
    isSet = null;
    this.listHasMomentChange.emit(this.listHasMoment);
  }
  public get listHasMoment(): boolean {
    return this.resultsSvc.history.synchSet['results-list'] !== null
  }
  public listHasMomentChange = new EventEmitter<boolean>();

  public set pucHasMoment(isSet: boolean) {
    isSet = isSet;
    this.listHasMomentChange.emit(this.pucHasMoment);
  }
  public get pucHasMoment(): boolean {
    return this.resultsSvc.history.synchSet['popup-control'] !== null;
  }
  public pucHasMomentChange = new EventEmitter<boolean>();


  public set infoHasMoment(isSet: boolean) {
    isSet = isSet;
    this.listHasMomentChange.emit(this.infoHasMoment);
  }
  public get infoHasMoment(): boolean {
    return this.resultsSvc.history.synchSet.info !== null;
  }

  public infoHasMomentChange = new EventEmitter<boolean>();

  public _isRenderingList = false;
  public isRenderingListChange = new EventEmitter<boolean>();
  public set isRenderingList(isIt: boolean) {
    isIt = isIt;
    this.isRenderingListChange.emit(this.isRenderingList);
  }
  public get isRenderingList(): boolean {
    return this.HasThisMoment('results-list') && this.HasThisSelection('results-list');
  }

  public _isRenderingPuc = false;
  public isRenderingPucChange = new EventEmitter<boolean>();
  public get isRenderingPuc(): boolean {
    return this.HasThisMoment('popup-control') && this.HasThisSelection('popup-control');
  }
  public set isRenderingPuc(isIt: boolean) {
    this._isRenderingPuc = isIt;
    this.isRenderingPucChange.emit(this._isRenderingPuc);
  }
  public _isRenderingInfo = false;
  public isRenderingInfoChange = new EventEmitter<boolean>();
  public get isRenderingInfo(): boolean {
    return this.HasThisMoment('info') && this.HasThisSelection('info');
  }
  public set isRenderingInfo(isIt: boolean) {
    isIt = isIt;
    this.isRenderingInfoChange.emit(this.isRenderingInfo);
  }

  public get hasSpatialMoment(): boolean {
    if (!this.moment) return false;
    switch (this.moment.context) {
      case 'gps-query':
      case 'gps-query-vis':
      case 'query':
      case 'query-by-feature':
      case 'query-by-feature-vis':
      case 'query-vis':
      case 'roi-query':
        return true;
      default:
        return false;
    }

  }

  private synchProxy: Synchable = null;
  // private inputType: 'rect' | 'point' | 'feature';

  get layer(): SLLayer {
    return this.sourceLayer;
  }
  get parentLayer(): string {
    return '';
  }
  get map(): ISLMap {
    return this.SLMap;
  }
  set map(newMap: ISLMap) {
    this.SLMap = newMap;
  }
  get queryAble(): boolean {
    if (this.searchable === false) {
      return false;
    }
    return [
      LayerTypeEnum.Vector.valueOf(),
      LayerTypeEnum.Relational.valueOf()
    ].indexOf(+this.type) > -1;
    // return (this.access >= LayerAccessLevel.Read);
  }

  get searchable(): boolean {
    if ([
      LayerTypeEnum.Vector.valueOf(),
      LayerTypeEnum.Relational.valueOf()
    ].indexOf(+this.type) === -1) {
      return false;
    }
    return this.data.search_on === 1;
  }

  set searchable(isSearchable: boolean) {
    this.data.search_on = isSearchable === true ? 1 : 0;
  }

  get layerVis(): boolean {
    if (!(this.isRenderingInfo || this.isRenderingList || this.isRenderingPuc)) return false;
    return ('' + this.data.layer_on) === '1';
  }
  set layerVis(vis: boolean) {
    this.data.layer_on = vis ? '1' : '0';
    this.UpdateLegend();
  }
  constructor(map: ISLMap, resultsSvc: ResultsService) {
    super({ layer_on: '1', opacity: 1, labels_on: 1, search_on: 1 }, map, null, null, resultsSvc);
    // const me = this;
    resultsSvc.resultChanges.subscribe((message: ResultChange) => {
      message = message;
      /*switch (message.change) {

         case 'results/selected':
          // this.ClearResults();
          break;
        case 'results/set':
          break;
        case 'results/active_layer/set':
        case 'results/selected':
        case 'results/synch/next':
        case 'results/synch/prev':
        case 'results/synch/first':
        case 'results/synch/last':
        case 'results/features/change':
          break;
      }
      */
    });
    this.synchProxy = {
      synchId: 'results-virtual-layer',
      synchables: ['results-list'],
      channel: 'renderer',
      handler: (event: SynchEvent) => {
        this.HandleSynchEvent(event);
      }
    }
    this.resultsSvc.AddSynchable(this.synchProxy);
    this.selections = {
      features: [],
      layer: null,
      layerId: null,
      unfeatures: [],
      channel: this.synchProxy.channel,
      context: null
    }
    this.ShowOrHide();
    this.resultsSvc.history.synchSetChange.subscribe(() => {

      this.UpdateIcons();
    })
    this.abilities.include_in_legend = true;
  }
  GetSub(id: string) {
    for (const sub of this.subs) {
      if (sub.id === id) {
        return sub;
      }
    }
  }
  HandleSynchEvent(event: SynchEvent) {

    if (event.channel === 'renderer') {
      switch (event.topic) {
        case 'render-request':
        case 'render':
          /*if (!!this.selectionData) {
            if (this.resultsSvc.CompareSelections(this.selectionData.selections,
              event.data.selections)) {
              this.touched = false;
              return;
            }
          }*/

          this.touched = true;
          this.moment = event.data.moment;
          this.selectionData = event.data;
          this.ShowOrHide();
          this.SetSubSelections(this.selectionData);
          break;
        // this.ShowResults(slLayer, selections.features, selections.unfeatures);
      }
      return;
    }
    if (event.topic === 'clear-results') {
      if (!!this.moment && this.isRenderingList) {
        delete this.moment;
      }
      this.hasResultsChange.emit(this.hasResults);

      this.UpdateIcons();
      this.RefreshIf(this.layer);
    }
    return;
    /*
    switch (event.source) {
      case 'search':
        this.SetRenderState('results-list');
        break;
      case 'query-by-feature':
      case 'query-by-feature-vis':
        if (event.topic === 'set-results') {
          this.inputType = 'feature';
        }
        this.SetRenderState('puc');
        break;
      case 'query':
      case 'query-vis':
        if (event.topic === 'set-results') {
          this.inputType = 'point';
        }
        this.SetRenderState('puc');

        break;
      case 'roi-query':
      case 'roi-query-vis':
        if (event.topic === 'set-results') {
          this.inputType = 'rect';
        }
        this.SetRenderState('puc');
        break;
      case 'result-list-selection':
        switch (event.topic) {
          case 'result-state-change':
            this.selections = event.data.contextState;
            this.ShowOrHide();
            if (this.layerOn && this.enabled) {
              for (const sub of this.subs) {
                sub.SetSelections(this.selections, this.inputType);
              }
            }
            if (this.enabled && this.layerOn) {
              this.Render();
            }
            break;

        }

      case 'results-list':
        switch (event.topic) {
          case 'clear-results':
            this.ClearResults();
            break;
        }
        break;
    }
    */
  }

  SetSubSelections(selections: ISelectionData) {
    for (const sub of this.subs) {
      sub.SetSelections(selections);
    }

  }
  ShowOrHide() {
    if (!this.selectionData) {
      if (!!this.enabled) { this.enabled = false; }
      if (!!this.layerOn) { this.layerOn = false; }
      return;
    }
    this.UpdateIcons();

    this.sourceLayer = this.selectionData.selections?.layer;// this.map.GetLayerById('' + this.resultsSvc.currentLayer.plid, true);
    if (!!this.selectionData.selections?.features) {
      if (this.selectionData.selections.features?.length > 0) {
        if (!this.enabled) { this.enabled = true; }
        if (!this.layerOn) { this.layerOn = true; }
        return;
      }
      if (this.selectionData.selections?.unfeatures?.length > 0) {
        if (!this.isEnabled) { this.enabled = true; }
        if (!this.layerOn) { this.layerOn = true; }
        return;
      }
    }

    if (!this.enabled) { this.enabled = false; }
    if (!this.layerOn) { this.enabled = false; }


  }
  ClearResults() {
    if (!this.enabled) { this.enabled = false; }
    if (!this.layerOn) { this.enabled = false; }
    (this.subSLLayers[0] as any).Clear();
    (this.subSLLayers[1] as any).Clear();
    (this.subSLLayers[2] as any).Clear();
    (this.subSLLayers[3] as any).Clear();


  }
  ShowResults(sourceLayer: SLLayer, selectedGids: Array<any> = [], unSelectedGids: Array<any> = []) {
    sourceLayer = selectedGids = unSelectedGids = null;
    /*
    this.sourceLayer = sourceLayer;
    (this.subSLLayers[0] as SelectedResultsLayer).ShowResults(sourceLayer, selectedGids, this.SLMap.styles);
    (this.subSLLayers[1] as UnSelectedResultsLayer).ShowResults(sourceLayer, unSelectedGids, this.SLMap.styles);
    (this.subSLLayers[2] as InputLayer).ShowResults(sourceLayer, selectedGids, this.SLMap.styles);
    (this.subSLLayers[3] as InputBufferLayer).ShowResults(sourceLayer, selectedGids, this.SLMap.styles);
    this.enabled = (selectedGids.length > 0) || (unSelectedGids.length > 0);
    this.layerOn = this.enabled;
    */
  }
  get overlayId(): string {
    return this.overlayLayer.id;
  }

  get defaultCriteria(): Array<any> | null {
    if (this.isPLayer === false) {
      return null;
    }
    return this.data.criteria;
  }
  get description(): string {
    return 'Results from: ' + this.sourceLayer?.name;
  }
  set description(desc: string) {
    desc = null;
    return;
  }

  get id(): string {
    return 'results';
  }
  private _includeInLegend: boolean = true;

  get includeInLegend(): boolean {
    return this._includeInLegend;
    return true;
  }
  set includeInLegend(include: boolean) {
    this._includeInLegend = include;
    this.subSLLayers.every((layer) => {
      layer.UpdateLegend();
      return true;
    })

    return;
  }

  get labelsOn(): boolean {
    /*if (this.sourceLayer && (this.inheritLabels === true)) {
      return this.sourceLayer.labelsOn;
    }*/
    return this.data?.labels_on === 1;

  }
  set labelsOn(isOn: boolean) {
    this.data.labels_on = isOn ? 1 : 0;
  }
  get srcLabelsOn(): boolean {
    if (this.sourceLayer) {
      return this.sourceLayer.labelsOn;
    }
    return false;
  }


  get plid(): string {
    return 'results';
  }
  get name(): string {
    return 'Search Results';
  }
  set name(name: string) {
    name = name;
    return;
  }
  get geom(): string {
    return LayerGeomtypes[LayerGeomtypes.Collection];
  }
  get searchtip(): string {
    return (this.data.searchtip === null) ? '' : this.data.searchtip;
  }
  set searchTip(tip: string) {
    this.data.searchTip = (tip === '') ? null : tip;
  }

  get type(): number {
    return LayerTypeEnum.Virtual_Results;
  }
  set type(layerType: number) {
    layerType = layerType;
  }
  get typeString(): string {
    return LayerTypeEnum[LayerTypeEnum.Virtual_SelectedResults];
  }
  get identifier() {
    if (this.isPLayer === true) {
      return this.plid;
    }
    return this.id;
  }


  Render(map: SLMap = null) {
    for (const sub of this.subSLLayers) {
      sub.Render(map, true);
    }
  }


  ZoomToFeatures() {
    if (!this.sourceLayer) return;
    // ToDo: Implement api call to get bounds for given feature ids
    const selGids: Array<any> = (this.subSLLayers[0] as SelectedResultsLayer).GetFeatures();
    const unselGids: Array<any> = (this.subSLLayers[1] as UnSelectedResultsLayer).GetFeatures();

    const gids = selGids.concat(unselGids);

    this.SLMap.component.HandleToolAction({
      action: 'info/zoom-to-features',
      layer: this.sourceLayer.id,
      features: gids.join(',')
    });
  }

  get subLayers(): Array<any> {
    return ['inputBuffer', 'inputFeatures', 'sel-results', 'unsel-results'];
  }
  get subSLLayers(): Array<SLLayer> {
    const layers: Array<SLLayer> = [];
    for (const layer of this.subLayers) {
      layers.push(this.SLMap.GetLayerById(layer, this.isPLayer));
    }
    return layers;
  }
  get hasSubLayers(): boolean {
    return true;
  }

  AddSubLayer(lyr: SLLayer) {
    this.subs.push(lyr);
  }
  set opacity(newOpacity: number) {
    this.data.opacity = newOpacity;
    this.overlayLayer.UpdateOpacity();
    this.UpdateSubOpacity(this.subSLLayers);
    this.change$.emit(this);
  }
  get opacity(): number {
    return this.data.opacity;
  }


  HasThisMoment(target: string) {
    if (!this.moment) {
      return false;
    }
    if (!!this.resultsSvc.history) {
      if (!!this.resultsSvc.history.synchSet) {
        if (!!this.resultsSvc.history.synchSet[target]) {
          return (this.resultsSvc.history.synchSet[target] === this.moment.id);
        }
      }
    }
    return false;

  }

  HasThisSelection(target: string) {
    if (!this.selectionData) {
      return false;
    }
    const collaborators = [];
    const syncs = this.resultsSvc.history.synchSet;
    for (const key in syncs) {
      if (syncs.hasOwnProperty(key)) {
        if (target === key) {
          continue;
        }
        if (syncs[key] === this.moment.id) {
          collaborators.push(key);
        }
      }
    }
    if (!this.selectionData?.selections?.id) return false;
    if (!!this.resultsSvc.history) {
      if (!!this.resultsSvc.history.synchResultsSet) {
        if (!!this.resultsSvc.history.synchResultsSet[target]) {
          if (this.resultsSvc.history.synchResultsSet[target] === this.selectionData?.selections?.id) {
            return true;
          }
          for (const collab of collaborators) {
            if (this.resultsSvc.history.synchResultsSet[collab] === this.selectionData?.selections?.id) {
              //return true;
            }
          }
        }
      }
    }
    return false;
  }
  UpdateIcons() {
    this.isRenderingList = this.isRenderingList;
    this.listHasMoment = this.listHasMoment;
    this.pucHasMoment = this.pucHasMoment;
    this.infoHasMoment = this.infoHasMoment;
    this.isRenderingPuc = this.isRenderingPuc;
    this.renderingInfo = this.renderingInfo;
    this.hasResultsChange.emit(this.hasResults);
    /*let state = false;
    state = state || this.isRenderingList;
    state = state || this.listHasMoment;
    state = state || this.pucHasMoment;
    state = state || this.infoHasMoment;
    state = state || this.isRenderingPuc;
    state = state || this.renderingInfo;
    */
    if ((this.isRenderingList || this.isRenderingPuc || this.isRenderingInfo) === false) {
      this.ClearResults();
    }
  }
  RequestRender(target: string) {
    const targetMomentId = this.resultsSvc.history.synchSet[target];
    this.resultsSvc.Synch({
      channel: targetMomentId,
      source: 'renderer',
      data: null,
      topic: 'render-request',
      synchFrom: target,
      synchTo: 'renderer'
    });
  }
  IsSynched(target: string) {
    if (!this.selectionData) {
      return false;
    }
    if (!this.moment?.id) return false;
    // const map = this.layer.SLMap;
    const targetMomentSynched = (this.resultsSvc.history.synchSet[target] === this.moment?.id);
    const targetSelectionSynched = (this.resultsSvc.history.synchResultsSet[target] === this.selectionData?.selections?.id);
    if (targetMomentSynched && targetSelectionSynched) {
      return true;
    }
    return false;
  }
  RefreshIf(layer: SLLayer) {
    if (this.sourceLayer && this.sourceLayer.id === layer.id) {
      this.Render();
    }
  }
  SetLabelInfo(info: any) {
    this.labelInfo = info;
  }
  GetLabelInfo() {
    return this.labelInfo;
  }
  HasFeatures(): boolean {
    return false;
  }
  IsVirtual(): boolean {
    return true;
  }
  GetSourceLayer() {
    return this.sourceLayer;
  }
  SendToResults() {
    this.isRenderingList = true;
    this.renderingResultList = true;
    let needSynch = false;
    let needSelectionSynch = false;
    this.touched = true;
    const resultMomentId = this.resultsSvc.history.synchSet['results-list'];

    if (!!this.moment && !!resultMomentId) {
      if (this.moment.id === resultMomentId) {
        this.selections = this.resultsSvc.history.synchResultsSet['results-list'];
        needSynch = true;
        needSelectionSynch = true;

      } else {
        this.moment = this.resultsSvc.history.GetMoment(resultMomentId);
        this.selections = this.resultsSvc.history.synchResultsSet['results-list'];
        needSynch = true;
        needSelectionSynch = true;
      }
    } else if (!!this.moment && !resultMomentId) {
      needSynch = true;
    } else if (!this.moment && !!resultMomentId) {
      this.moment = this.resultsSvc.history.GetMoment(resultMomentId);
      this.selections = this.resultsSvc.history.synchResultsSet['results-list'];
      needSynch = true;
    } else { //!this.moment && !resultMoment
      if (!!this.resultsSvc.history.lastMoment) {
        this.moment = this.resultsSvc.history.lastMoment;
        this.selections = this.resultsSvc.history.synchResultsSet['results-list'];
        // this.resultsSvc.history.synchSet['results-list'] = this.moment.id;
        // this.resultsSvc.history.synchResultsSet['results-list'] =
        needSynch = true;

      } else {
        return;
      }
    }
    this.RefreshIf(this.layer);
    if (needSynch === true) {
      this.resultsSvc.Synch({
        channel: this.synchProxy.channel,
        data: { moment: this.moment },
        source: this.synchProxy.synchId,
        topic: 'synch-data',
        synchFrom: this.synchProxy.synchId,
        synchTo: 'results-list'

      });

      this.resultsSvc.history.UpdateMomentSyncs();
    }

    this.isRenderingList = true;
    this.layer?.SLMap?.src?.layersView?.Refresh();
    this.Render();
    // this.ZoomToFeatures();

  }
  SendToPUC() {
    this.renderingPUC = true;
    this.isRenderingPuc = true;
    let needSynch = false;
    let needSelectionSync = false;
    this.touched = true;
    const pucMan = this.SLMap.component.PUCMan;
    const pucMomentId = this.resultsSvc.history.synchSet['popup-control'];
    if (!!this.moment && !!pucMomentId) {
      if (this.moment.id === pucMomentId) {
        // this.selections = this.resultsSvc.history.synchResultsSet['popup-control'];
        needSynch = true;
        needSelectionSync = true;
      } else {
        this.moment = this.resultsSvc.history.GetMoment(pucMomentId);
        // this.selections = this.resultsSvc.history.synchResultsSet['popup-control'];
        needSynch = true;
      }
    } else if (!!this.moment && !pucMomentId) {
      needSynch = true;
    } else if (!this.moment && !!pucMomentId) {
      this.moment = this.resultsSvc.history.GetMoment(pucMomentId);
      needSynch = true;
    } else { //!this.moment && !pucMoment
      if (!!this.resultsSvc.history.lastMoment) {
        this.moment = this.resultsSvc.history.lastMoment;
        this.resultsSvc.history.synchSet['popup-control'] = this.moment.id;
      } else {
        // this.Render();
        // pucMan.ShowResults(this.moment, true, true);
        // return;
      }
    }
    // pucMan.ShowResults(this.moment);
    // pucMan.ShowPopup();
    this.isRenderingPuc = true;
    this.RefreshIf(this.layer);
    pucMan.SetPoint(undefined, false);

    if (needSynch) {
      this.resultsSvc.Synch({
        channel: this.synchProxy.channel,
        data: { moment: this.moment, render: true },
        source: this.synchProxy.synchId,
        topic: 'synch-data',
        synchFrom: this.synchProxy.synchId,
        synchTo: 'popup-control'

      });
      this.resultsSvc.history.UpdateMomentSyncs();
    }
    window.requestAnimationFrame(() => {
      pucMan.ZoomToPoint();
    });
  }
  SendToInfo() {
    this.isRenderingList = true;
    this.renderingResultList = true;
    let needSynch = false;
    let needSelectionSynch = false;
    this.touched = true;
    const resultMomentId = this.resultsSvc.history.synchSet['info'];

    if (!!this.moment && !!resultMomentId) {
      if (this.moment.id === resultMomentId) {
        needSynch = true;
        needSelectionSynch = true;

      } else {
        this.moment = this.resultsSvc.history.GetMoment(resultMomentId);
        needSynch = true;
        needSelectionSynch = true;
      }
    } else if (!!this.moment && !resultMomentId) {
      needSynch = true;
    } else if (!this.moment && !!resultMomentId) {
      this.moment = this.resultsSvc.history.GetMoment(resultMomentId);
      this.selections = this.resultsSvc.history.synchResultsSet['info'];
      needSynch = true;
    } else { //!this.moment && !resultMoment
      if (!!this.resultsSvc.history.lastMoment) {
        this.moment = this.resultsSvc.history.lastMoment;
        this.selections = this.resultsSvc.history.synchResultsSet['info'];
        // this.resultsSvc.history.synchSet['results-list'] = this.moment.id;
        // this.resultsSvc.history.synchResultsSet['results-list'] =
        needSynch = true;

      }
    }
    if (needSynch === true) {
      this.resultsSvc.Synch({
        channel: this.synchProxy.channel,
        data: { moment: this.moment },
        source: this.synchProxy.synchId,
        topic: 'synch-data',
        synchFrom: this.synchProxy.synchId,
        synchTo: 'info'

      });

      this.resultsSvc.history.UpdateMomentSyncs();
    }

    this.isRenderingList = true;
    this.RefreshIf(this.layer);

    this.Render();
    // this.ZoomToFeatures();

  }
}
